// Reused theme tokens — already defined in src/styles/themes/default/colors.scss
// and already consumed by MAP_LAYER.FLIGHT_PATH_FILL's step expression.
export const LEGEND_COLOR_VARS = [
    '--map-flight-path-rate-low-color',
    '--map-flight-path-rate-medium-color',
    '--map-flight-path-rate-high-color'
] as const;

// For the degenerate min === max case we show a single "zone mask" swatch
// using the medium rate token (middle of the 3-color spectrum) — no
// meaningful variance to rank low/high across.
export const ZONE_MASK_COLOR_VAR = '--map-flight-path-rate-medium-color';

export const LEGEND_BIN_COUNT = LEGEND_COLOR_VARS.length;
